import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import './CardItem.module.scss';
import customIsoString from 'utilities/custom-iso-string';
import { Draggable } from 'react-beautiful-dnd';

import InputHomework from 'components/UI/Popup/InputHomework/InputHomework';
import PlanHomework from 'components/UI/Popup/PlanHomework/PlanHomework';
import EditSubject from 'components/UI/Popup/EditSubject/EditSubject';
import EditSubjectDetails from 'components/UI/Popup/EditSubjectDetails/EditSubjectDetails';

//import actions
import {
    homeworkDate,
    homeworkSubject,
    homeworkTimeslot,
    linkEventToHomework,
    homeworkLoadExisting,
    homeworkReset
} from 'actions/new-homework';

import { timeslot, startDate } from 'actions/new-timeslot';
import destroyEvent from 'actions/event/destroy';

//import components
import Subject from 'components/UI/Subject/Subject';
import HomeworkView from '../../Popup/HomeworkView/HomeworkView';

//import Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const mapStateToProps = (state, props) => {
    return {
        agendaVisibility: state.agenda,
        colors: state.color.entities,
        subjects: state.user_subject.entities,
        tasks: state.task.entities
    };
};

const mapDispatchToProps = {
    homeworkDate,
    homeworkSubject,
    homeworkTimeslot,
    timeslot,
    startDate,
    linkEventToHomework,
    homeworkLoadExisting,
    homeworkReset,
    destroyEvent
};

class CardItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showInputHomework: false,
            showPlanHomework: false,
            showHomeworkView: false,
            showScheduleSubject: false,
            showEditSubject: false,
            showEditSubjectDetails: false,
            showCardConflict: false,
            selectedResolve: null
        };

        this.showInputHomework      = this.showInputHomework.bind(this);
        this.closeInputHomework     = this.closeInputHomework.bind(this);
        this.handleItemClick        = this.handleItemClick.bind(this);
        this.closePlanHomework      = this.closePlanHomework.bind(this);
        this.showPlanHomework       = this.showPlanHomework.bind(this);
        this.showHomeworkView       = this.showHomeworkView.bind(this);
        this.hideHomeworkView       = this.hideHomeworkView.bind(this);
        this.showScheduleSubject    = this.showScheduleSubject.bind(this);
        this.showEditSubject        = this.showEditSubject.bind(this);
        this.closeEditSubject       = this.closeEditSubject.bind(this);
        this.finishConflict         = this.finishConflict.bind(this);
        this.generateTimeValue      = this.generateTimeValue.bind(this);
        this.showEditSubjectDetails = this.showEditSubjectDetails.bind(this);
        this.closeEditSubjectDetails = this.closeEditSubjectDetails.bind(this);
        this.openCardConflict       = this.openCardConflict.bind(this);
        this.closeCardConflict      = this.closeCardConflict.bind(this);
        this.setConflictRef         = this.setConflictRef.bind(this);
        this.setConflictResolve     = this.setConflictResolve.bind(this);
        this.handleClickOutside     = this.handleClickOutside.bind(this);
    }

    showInputHomework() {
        this.setState({ showInputHomework: true });

        let date = customIsoString(this.props.date).split('T')[0]; 

        if (this.props.homework) {
            this.props.linkEventToHomework(this.props.period);
            this.props.homeworkLoadExisting(this.props.homework);
        }
        else {
        
            this.props.homeworkDate(date);
            this.props.homeworkSubject(this.props.period.user_subject_id);

            //determine order. If this is a block item, we set the homework for the previous order
            let order = this.props.order;
            if (this.props.period.block) {
                order = order - 1;
            }

            this.props.homeworkTimeslot(order);
        }
    }

    showScheduleSubject() {
        this.setState({ showInputHomework: true });
        //TODO For new subject input popup
        // let date = customIsoString(this.props.date).split('T')[0];
        // this.props.homeworkDate(date);
        // this.props.homeworkSubject(this.props.period.user_subject_id);

        // //determine order. If this is a block item, we set the homework for the previous order
        // let order = this.props.order;
        // if (this.props.period.block) {
        //     order = order - 1;
        // }

        // this.props.homeworkTimeslot(order);
    }

    showHomeworkView() {
        this.setState({ showHomeworkView: true });
    }

    hideHomeworkView(event) {
        //we need to stop propagation in order to prevent a click on the cardItem, that would open the popup again
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState({ showHomeworkView: false });
    }

    showPlanHomework() {
        this.setState({ showPlanHomework: true });
    }

    closeInputHomework(event) {
        //we need to stop propagation in order to prevent a click on the cardItem, that would open the popup again
        if (event) {

            event.preventDefault();
            event.stopPropagation();
        }
        this.setState({ showInputHomework: false });
        setTimeout(() => this.props.homeworkReset(), 300);
    }

    handleItemClick() {

        if (this.props.notClickable || this.props.past) {

            if (this.props.homework) {
                return this.showHomeworkView();
            }

            return;
        }

        if (this.props.empty && this.props.order < 99) {
            //TODO Deze if statement moet nog naar wat anders waarschijnlijk in de final versie
            this.props.onScheduleItemClick();
            let date = customIsoString(this.props.date).split('T')[0];
            this.props.startDate(date);
            this.props.timeslot(this.props.order);
            this.props.homeworkTimeslot(this.props.order);
            this.props.homeworkDate(date);
            return;
        }

        let subject = this.props.period && this.props.period.user_subject_id && this.props.subjects && this.props.subjects.allIds.length > 0 && this.props.subjects.byId[this.props.period.user_subject_id];

        if (this.state.showPlanHomework || this.state.showInputHomework) {
            return;
        }
        
        if (this.props.isSchedule) {
            this.props.handleClick(this.props.order);
            return;
        }

        if (subject && subject.subject == 'Overige Taak') {
            return;
        }

        if (this.props.homework && this.props.homework.hasBeenPlanned) {
            this.showHomeworkView();
            return;
        }

        if (!this.props.empty && !this.props.homework) {
            this.props.linkEventToHomework(this.props.period);
            this.showInputHomework();
            return;
        }

        if (this.props.order == 99) {
            this.props.onAgendaItemClick();
        }

        let tasks = this.props.tasks.allIds.map((taskId) => this.props.tasks.byId[taskId]);
        let tasksForHomework = tasks.filter((task) => task.homework_id == this.props.homework.id);

        if (!this.props.empty && this.props.homework && tasksForHomework.length > 0) {
            alert('Voor dit huiswerk zijn al taken gemaakt maar nog niet ingepland, plan deze eerst in voordat je verder kan gaan.');
            return;
        }

        if (!this.props.empty && this.props.homework && !this.props.homework.hasBeenPlanned) {
            this.showPlanHomework();
            return;
        }

        
    }

    closePlanHomework(event) {
        //we need to stop propagation in order to prevent a click on the cardItem, that would open the popup again
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
       
        this.setState({ showPlanHomework: false });
    }

    getCombineStyle(style, snapshot, duration) {
        if (!snapshot.isDragging) return {};
        return {
            ...style,
            opacity: 1,
            height: `${45 * duration}px`,
            //backgroundColor: '#E5E5E5'
            alignItems: 'flex-start',
            paddingTop: '7px'
        };
    };

    showEditSubject() {
        this.setState({
            showInputHomework: false,
            showHomeworkView: false,
            showEditSubject: true,
            subjectEditId: this.props.period.user_subject_id
        });
    }

    closeEditSubject() {
        this.setState({
            showEditSubject: false,
            subjectEditId: null
        });
    }

    showEditSubjectDetails() {
        this.setState({
            showInputHomework: false,
            showHomeworkView: false,
            showEditSubjectDetails: true
        });
    }

    closeEditSubjectDetails() {
        this.setState({
            showEditSubjectDetails: false
        });
    }

    padNumber(number) {
        if(!number) {
            return '00';
        }

        return (number < 10 ? '0' : '') + number;
    }

    generateTimeValue() {

        if (this.props.period.duration > 1) { //if this period has a duration longer then 1, we need to calculate the correct end-time from the timeslot values

            let startValues = this.props.times[this.props.period.timeslot];
            let endValues = this.props.times[this.props.period.timeslot + this.props.period.duration - 1];

            return `${this.padNumber(startValues?.[0])}:${this.padNumber(startValues?.[1])} - ${this.padNumber(endValues?.[2])}:${this.padNumber(endValues?.[3])}`;

        } else {
            let values = this.props.times[this.props.period.timeslot];
            return `${this.padNumber(values[0])}:${this.padNumber(values[1])} - ${this.padNumber(values[2])}:${this.padNumber(values[3])}`;
        }        
    }

    setConflictRef(node) {
        this.conflictRef = node;
    }

    setConflictResolve(id) {
        this.setState({
            selectedResolve: id
        });
    }

    openCardConflict(event) {
        
        if (event.target.id == 'conflict-item' && this.state.showCardConflict) {

            this.setState({
                showCardConflict: false,
            });
            document.removeEventListener('mousedown', this.handleClickOutside);
        } else {
            this.setState({
                showCardConflict: true,
            });
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    }

    closeCardConflict(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
            showCardConflict: false,
        });
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {

        if (this.conflictRef && !this.conflictRef.contains(event.target)) {
            this.setState({
                showCardConflict: false
            });
            document.removeEventListener('mousedown', this.handleClickOutside);
        }

    }

    finishConflict(editMode) {
        let allOtherItems = this.props.conflictingItems.filter((item) => item.id != this.state.selectedResolve);
            
        allOtherItems.forEach((event) => {
            if (event.isRecurring) {

                this.props.destroyEvent(event.id, {
                    id: event.id,
                    redit: editMode ? editMode : 'single',
                    origid: event.origid,
                    ristart: customIsoString(this.props.date, true),
                    startDateUtc: customIsoString(this.props.date, true),
                });

            } else {
                this.props.destroyEvent(event.id, {
                    id: event.id,
                    redit: ''
                });
            }
        });
    }

    render() {
        const { homework, timer, style, large, period, date, weekend, isSchedule, order, hideInfo, tasks, draggingASchedule }  = this.props;
        //Determines description background color based om marked prop
        
        let subject = period && period.user_subject_id && this.props.subjects && this.props.subjects.allIds.length > 0 && this.props.subjects.byId[period.user_subject_id];

        let isOtherTask = subject && subject.subject == 'Overige Taak';

        let isHomeworkFinished = false;

        if (homework && homework.hasBeenPlanned) {
            let tasksForHomework = tasks.allIds.map((taskId) => tasks.byId[taskId]).filter((task) => task.homework_id == homework.id);
            isHomeworkFinished = tasksForHomework.length == tasksForHomework.filter((task) => task.status === 'finished').length;
        }
        return (
            <Fragment>
                {
                    !this.props.conflict &&
                        <Fragment>
                            {
                                ((!this.props.empty && period && !period.block) || !this.props.empty && this.props.notClickable && this.props.hideInfo) ?
                            
                                    <Draggable draggableId={`${period.id}`} index={0} isDragDisabled={this.props.disableDrag || this.props.past}>
                                        {(provided, snapshot) => (
                                            <div onClick={this.handleItemClick}  styleName={(timer ? 'timer ':'') + 'carditem-background '+(large ? 'large' : '') + (this.props.past && homework && homework.hasBeenPlanned ? ' hasHomeworkInPast ' : '') + (draggingASchedule ? ' draggingASchedule ' : '') + (weekend ? 'weekendColor ' : '') + (period && period.block ? 'block ' : 'top') + (period && period.duration == 1 ? ' single ' : ' ') + (period && period.last ? ' last ' : ' ') +(homework && !homework.hasBeenPlanned ? 'needsToBePlanned ' : '') + (isHomeworkFinished ? ' isFinished ' : '') + (homework && (homework.hasBeenPlanned && !isHomeworkFinished) || isOtherTask || (isSchedule && subject) ? ' hasBeenPlanned ' : '')} {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                ref={provided.innerRef}
                                                style={this.getCombineStyle(provided.draggableProps.style, snapshot, period.duration)} >
                                                <div styleName="carditem-content">
                                
                                                    <Fragment>
                                                        {
                                                            isOtherTask ?
                                                                <Subject misc color='#f8e764' />
                                                                :
                                                                <Subject abbreviation={subject && subject.subject_abbreviation} color={subject && (homework || isSchedule) && subject.color_id && this.props.colors.allIds.length > 0 && (this.props.agendaVisibility.color ? this.props.colors.byId[subject.color_id].color : '#94bfcf') } />
                                                        }
                                    
                                                        {
                                                            ((homework || isOtherTask) && !isSchedule) &&
                                            <div styleName='homework'>
                                                {
                                                    isOtherTask ?
                                                        <div styleName='description'><p>{period.room}</p></div>
                                                        :
                                                        <Fragment>
                                                            <p styleName="type">
                                                                {homework.type == 'make' && 'M'}
                                                                {homework.type == 'learn' && 'L'}
                                                                {
                                                                homework.type ==
                                                                    "make_learn" && (
                                                                    <Fragment>
                                                                        M<br />L
                                                                    </Fragment>
                                                                )}
                                                                {
                                                                homework.type == "read" && (
                                                                    <Fragment>
                                                                        L<br />Z
                                                                    </Fragment>
                                                                )}
                                                            </p>
                                                            <div styleName='description'>{!homework.mark ? <p>{homework.description} {(homework.note || homework.image) && <FontAwesomeIcon icon={[ 'fal','paperclip' ]}/>}</p> : <p><mark styleName="mark">{homework.description} {(homework.note || homework.image) && <FontAwesomeIcon icon={[ 'fal','paperclip' ]}/>}</mark></p>}</div>
                                                        </Fragment>
                                                }
                                                
                                            </div>

                                                        }
                                                        <div styleName='summary'>
                                                            {!hideInfo && this.props.agendaVisibility.hour && <p styleName="order">
                                                                {this.props.times ? this.generateTimeValue() : period.timeslot}
                                                            </p> }
                                                            {!isOtherTask && !hideInfo && this.props.agendaVisibility.room && <p>{period && period.room}</p> }
                                                            {!isOtherTask && !hideInfo && this.props.agendaVisibility.teacher && <p>{subject && subject.teacher_abbreviation}</p> }
                                                        </div>
                                    
                                
                                                    </Fragment>
                                

                                
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                    :
                                    
                                    <div onClick={this.handleItemClick} styleName={(timer ? 'timer ':'') + 'carditem-background '+(large ? 'large' : '') + (this.props.past && homework && homework.hasBeenPlanned ? ' hasHomeworkInPast ' : '') + (weekend ? 'weekendColor ' : '') + (draggingASchedule ? ' draggingASchedule ' : '') + (period && period.block ? ' block ' : ' top ') + (period && period.last ? ' last ' : ' ') +(homework && !homework.hasBeenPlanned ? ' needsToBePlanned ' : ' ') + (isHomeworkFinished ? ' isFinished ' : ' ') + ' ' + (homework && (homework.hasBeenPlanned && !isHomeworkFinished) || isOtherTask || (isSchedule && subject) ? ' hasBeenPlanned ' : ' ')} >
                                        <div styleName="carditem-content">
                                        </div>
                        
                        
                                    </div>
                            }

                            <Modal open={this.state.showInputHomework} onClose={this.closeInputHomework} center styles={{
                                modal: {
                                    background: 'none',
                                    boxShadow: 'none'
                                },
                                closeIcon: {
                                    fill: '#fff',
                                    cursor: 'pointer'
                                }
                            }}>
                                <InputHomework handleClose={this.closeInputHomework} handleSubjectEditClick={this.showEditSubject} handleDetailsEditClick={this.showEditSubjectDetails}/>
                            </Modal>
                            <Modal open={this.state.showEditSubject} onClose={this.closeEditSubject} center styles={{
                                modal: {
                                    background: 'none',
                                    boxShadow: 'none'
                                },
                                closeIcon: {
                                    fill: '#fff',
                                    cursor: 'pointer'
                                }
                            }}>
                                <EditSubject subjectId={this.state.subjectEditId} onClose={this.closeEditSubject}/>
                            </Modal>
                            <Modal open={this.state.showEditSubjectDetails} onClose={this.closeEditSubjectDetails} center styles={{
                                modal: {
                                    background: 'none',
                                    boxShadow: 'none'
                                },
                                closeIcon: {
                                    fill: '#fff',
                                    cursor: 'pointer'
                                }
                            }}>
                                <EditSubjectDetails event={period} onClose={this.closeEditSubjectDetails} />
                            </Modal>
                            <Modal open={this.state.showHomeworkView} onClose={this.hideHomeworkView} center styles={{
                                modal: {
                                    background: 'none',
                                    boxShadow: 'none'
                                },
                                closeIcon: {
                                    fill: '#fff',
                                    cursor: 'pointer'
                                }
                            }}>
                                <HomeworkView handleClose={this.hideHomeworkView} past={this.props.past} period={period} homework={homework} handleHomeworkClick={this.showInputHomework} handleSubjectEditClick={this.showEditSubject} handleDetailsEditClick={this.showEditSubjectDetails}/>
                            </Modal>

                            {
                                homework &&
                

                    <CustomPopup
                        open={this.state.showPlanHomework}
                        order={order}
                        handleClose={this.closePlanHomework}
                    >
                        <PlanHomework handleClose={this.closePlanHomework} handleHomeworkClick={this.showInputHomework} homework={homework} />
                    </CustomPopup>
                            }
                    
                        </Fragment>
                }

                {
                    this.props.conflict &&
                    <ConflictWrapper
                        order={order}
                        conflictRef={this.setConflictRef}
                        onConflictClick={this.openCardConflict}
                        showCardConflict={this.state.showCardConflict}
                        onClose={this.closeCardConflict}
                        resolveConflict={this.state.selectedResolve}
                        conflictingItems={this.props.conflictingItems}
                        selectConflictResolve={this.setConflictResolve}
                        subjects={this.props.subjects}
                        colors={this.props.colors}
                        finishConflict={this.finishConflict}
                    />
                }
            </Fragment>
        );
    }

}

class CustomPopup extends Component {

    constructor() {
        super();

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    
    /**
       * Set the wrapper ref
       */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    /**
       * Alert if clicked on outside of element
       */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.handleClose();
        }
    }

    render() {

        if (!this.props.open) {
            return null;
        }

        return (
            
            <div ref={this.setWrapperRef} styleName={`customPopup order-${this.props.order}`}>
                {this.props.children}
            </div>

        );

    }
}

class ConflictWrapper extends Component {
    constructor() {
        super();

        this.finishConflict = this.finishConflict.bind(this);
    }

    finishConflict(editMode) {
        this.props.finishConflict(editMode);
    }

    render() {
        let selectedEvent = this.props.conflictingItems.find((item) => item.id == this.props.resolveConflict);
        return (
            <div id='conflict-item'  styleName='conflict-wrapper' onClick={(even) => this.props.onConflictClick(event)} ref={this.props.conflictRef}>
                {
                    this.props.showCardConflict && 
                            <div styleName={`popup order-${this.props.order} ${this.props.conflictingItems.length > 2 ? ' needsScroll' : ''} `}>
                                <div styleName='triangle'/>
                                <div styleName='text'>
                                    <h5>Welk vak wil je laten staan?</h5>
                                    <p>De volgende vakken zijn op hetzelfde uur gepland. Welk vak wil je laten staan?</p>
                                    <p>Selecteer het vak dat je wil behouden.</p>
                                    <p><b>Let op:</b> De andere vakken worden verdwijderd inclusief bijbehorend huiswerk.</p>
                                </div>
                                <div styleName='subjects'>
                                    {
                                        this.props.conflictingItems.map((event, index) =>
                                            <div key={index} styleName={`subject ${this.props.resolveConflict ? this.props.resolveConflict === event.id ? 'selectedResolve' : 'notSelected' : ''}`} onClick={() => this.props.selectConflictResolve(event.id)} >
                                                <div style={{ display: 'flex' }}>
                                                    <Subject abbreviation={this.props.subjects.byId[event.user_subject_id].subject_abbreviation}
                                                        color={this.props.colors.byId[this.props.subjects.byId[event.user_subject_id].color_id].color} />
                                                    <div styleName={`subject-details ${this.props.resolveConflict ? this.props.resolveConflict === event.id ? 'selectedResolve' : 'notSelected' : ''}`}>
                                                        <p><b>{this.props.subjects.byId[event.user_subject_id].subject}</b></p>
                                                        <div styleName='homework-detail'>
                                                            <p><b></b>Geen huiswerk</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div styleName={`frequency ${this.props.resolveConflict ? this.props.resolveConflict === event.id ? 'selectedResolve' : 'notSelected' : ''}`}>
                                                    <p>
                                                        {
                                                            !event.isRecurring && 'Eenmalig'
                                                        }
                                                        {
                                                            event.isRecurring? (event.recurrencePattern.includes('WEEKLY') && event.recurrencePattern.includes('INTERVAL=1') && 'Elke week') : ''
                                                        }
                                                        {
                                                            event.isRecurring? (event.recurrencePattern.includes('WEEKLY') && event.recurrencePattern.includes('INTERVAL=2') && 'Elke 2 weken') : ''
                                                        }
                                                        {
                                                            event.isRecurring ? (event.recurrencePattern.includes('WEEKLY') && event.recurrencePattern.includes('INTERVAL=4') && 'Elke 4 weken') : ''
                                                        }
                                                    </p>
                                                </div>
                                                <FontAwesomeIcon styleName={`icon ${this.props.resolveConflict ? this.props.resolveConflict === event.id ? 'selectedResolve' : 'notSelected' : ''}`} icon={this.props.resolveConflict ? this.props.resolveConflict === event.id ? [ 'fas', 'check-circle' ] : [ 'fas', 'times-circle' ] : [ 'fal', 'circle' ]}/>
                                            </div>
                                        )
                                    }
                                </div>
                                {/* De onderste divs moeten afhankelijk van de vakken in de popup gerendered worden. Is het een vak met herhaling -> buttons div met 3 opties. Anders de div met 2 opties */}
                                {/* <div styleName='buttons'>
                                    <p>Annuleren</p>
                                    <p styleName='blue' style={{ width: 'auto' }}>Toepassen</p>
                                </div> */}
                                <div styleName='buttons'>
                                    <p onClick={this.props.onClose} style={{ width: '60px', textAlign: 'center' }}>Annuleren</p>

                                    {
                                        selectedEvent && selectedEvent.isRecurring && this.props.conflictingItems.filter((event) => event.isRecurring).length > 1 ? 
                                            <Fragment>
                                                <div styleName='border'/>
                                                <p onClick={() => this.finishConflict('future')} styleName='blue'>Toepassen vanaf hier</p>
                                                <div styleName='border'/>
                                                <p onClick={() => this.finishConflict('single')} styleName='blue'>Alleen hier toepassen</p>
                                            </Fragment>
                                            :
                                            <p styleName='blue' onClick={() => this.finishConflict()} style={{ width: 'auto' }}>Toepassen</p>
                                    }
                                </div>
                            </div>
                }
                <p id='conflict-item' styleName='text'>Dubbel vak gepland</p>
                <div id='conflict-item' styleName='circle'>
                    <p id='conflict-item'>{this.props.conflictingItems.length}</p>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardItem);
